import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, AuthWebService } from 'src/app/shared/services';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
    constructor(
        private authWebService: AuthWebService,
    ) {}

    async ngOnInit() {
        await this.authWebService.getAuthWeb(true);
    }
}
